import { queryClient } from '@hotjar/webapp/utils/react-query';
import { CURRENT_USER_QUERY_KEY } from '@hotjar/user';
import { getCurrentUser } from '@hotjar/user';
import { useSiteStore } from '@hotjar/site';
import { getUserResources, USER_RESOURCES_QUERY_KEY } from '@hotjar/user-resources';
import { fetchSegments } from '../../RecordingsPage/utils/fetchSegments';

import type { Site } from '@hotjar/site';

export const prefetchData = async (): Promise<void> => {
  const preferredCurrentSiteId = useSiteStore.getState().preferredCurrentSiteId;

  // Fetch user
  const currentUser = await queryClient.fetchQuery(CURRENT_USER_QUERY_KEY, getCurrentUser);
  if (!currentUser) {
    return;
  }

  // Fetch user resources to get the site
  const userResources = await queryClient.fetchQuery(
    USER_RESOURCES_QUERY_KEY,
    getUserResources.bind(null, currentUser.id),
  );

  const currentSite =
    userResources.sites.find((site) => site.id === preferredCurrentSiteId) ||
    userResources.sites[0];

  // Fetch segments
  fetchSegments(currentSite as unknown as Site);
};
